/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegisterRequestV2
 */
export interface RegisterRequestV2 {
    /**
     * 
     * @type {string}
     * @memberof RegisterRequestV2
     */
    registeredContractNumber?: string | null;
}

/**
 * Check if a given object implements the RegisterRequestV2 interface.
 */
export function instanceOfRegisterRequestV2(value: object): value is RegisterRequestV2 {
    return true;
}

export function RegisterRequestV2FromJSON(json: any): RegisterRequestV2 {
    return RegisterRequestV2FromJSONTyped(json, false);
}

export function RegisterRequestV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterRequestV2 {
    if (json == null) {
        return json;
    }
    return {
        
        'registeredContractNumber': json['registered_contract_number'] == null ? undefined : json['registered_contract_number'],
    };
}

export function RegisterRequestV2ToJSON(json: any): RegisterRequestV2 {
    return RegisterRequestV2ToJSONTyped(json, false);
}

export function RegisterRequestV2ToJSONTyped(value?: RegisterRequestV2 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'registered_contract_number': value['registeredContractNumber'],
    };
}

